import React from "react";
import Archive from "../Components/Archive";
import "react-toastify/dist/ReactToastify.css";
import "../App.css";
import "../Styles/AdminPages.css";

function ArchivePage() {
  return (
    <section className="admin-page" aria-labelledby="archive-page-title">
      <header className="admin-page__header">
        <div>
          <p className="admin-page__eyebrow">CONTENT HISTORY</p>
          <h1 id="archive-page-title">Archived modules</h1>
          <p className="admin-page__intro">
            Review archived learning content and restore modules when needed.
          </p>
        </div>
      </header>
      <div className="admin-page__archive-panel">
        <Archive />
      </div>
    </section>
  );
}

export default ArchivePage;
